export default __webpack_public_path__ + "static/media/Error-404.e3738995.gif";